import styled from "styled-components";
import media from "constants/media";

export const SaldocheckFormStyled = styled.div`
    padding: 42px 20px 28px;

    text-align: center;

    background-color: var(--color-white);

    ${media.mdUp`
        padding: 60px 70px;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
    `};
`;

export const HeadingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    ${media.mdUp`
        flex-direction: row;
        justify-content: space-between;
    `};
`;

export const Content = styled.div`
    position: relative;

    width: 100%;
    max-width: 980px;
    min-height: 100vh;
    margin: 0 auto;
    padding: 40px 0;

    background: var(--color-white);

    ${media.mdUp`
        min-height: 0;
        padding: 0;
    `};
`;

export const Image = styled.img`
    max-width: 100%;
    max-height: 80vw;
`;

export const Label = styled.h2`
    margin-bottom: 10px;

    font-weight: 500;
    font-size: 14px;
    line-height: 25px;

    ${media.mdUp`
        margin-bottom: 0;

        font-size: 16px;
    `}
`;

export const Close = styled.button`
    position: absolute;
    top: 20px;
    right: 20px;

    width: 12px;

    cursor: pointer;

    svg {
        width: 100%;
    }
`;

export const SubmitButton = styled.div`
    display: flex;
    justify-content: center;
`;
